import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gift, CheckCircle2 } from 'lucide-react';
export function ValueStack() {
  const items = [{
    title: 'Ebook Principal: El Código Hormonal 40+',
    value: 197,
    icon: <BookOpen className="w-6 h-6 text-brand-green" data-id="element-273" />,
    isMain: true
  }, {
    title: 'Bonus 1: SOS Sofocos y Ansiedad Nocturna',
    value: 47,
    icon: <Gift className="w-6 h-6 text-brand-gold" data-id="element-274" />
  }, {
    title: 'Bonus 2: Lista de Compras Hormone-Safe',
    value: 27,
    icon: <Gift className="w-6 h-6 text-brand-gold" data-id="element-275" />
  }, {
    title: 'Bonus 3: Recetario "Cenas en 10 Minutos"',
    value: 67,
    icon: <Gift className="w-6 h-6 text-brand-gold" data-id="element-276" />
  }, {
    title: 'Bonus 4: Guía de Suplementación Estratégica',
    value: 47,
    icon: <Gift className="w-6 h-6 text-brand-gold" data-id="element-277" />
  }, {
    title: 'Bonus 5: Protocolo de Magnesio para el Sueño',
    value: 37,
    icon: <Gift className="w-6 h-6 text-brand-gold" data-id="element-278" />
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    show: {
      opacity: 1,
      x: 0
    }
  };
  return <section className="py-20 px-4 bg-white" id="oferta" data-id="element-279">
      <div className="max-w-3xl mx-auto" data-id="element-280">
        <div className="text-center mb-12" data-id="element-281">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-brand-green" data-id="element-282">
            Esto es todo lo que recibes hoy al unirte a la Revolución Hormonal:
          </h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true
      }} className="space-y-4" data-id="element-283">
          {items.map((item, index) => <motion.div key={index} variants={itemVariants} className={`flex items-center justify-between p-4 md:p-6 rounded-2xl border ${item.isMain ? 'bg-brand-cream border-brand-green shadow-md' : 'bg-white border-brand-cream hover:border-brand-gold/50 transition-colors'}`} data-id="element-284">
              <div className="flex items-center gap-4" data-id="element-285">
                <div className={`p-3 rounded-xl ${item.isMain ? 'bg-white' : 'bg-brand-cream'}`} data-id="element-286">
                  {item.icon}
                </div>
                <h3 className={`font-bold ${item.isMain ? 'text-lg md:text-xl text-brand-green' : 'text-base md:text-lg text-brand-gray'}`} data-id="element-287">
                  {item.title}
                </h3>
              </div>
              <div className="text-right ml-4" data-id="element-288">
                <span className="text-sm text-brand-gray/50 line-through block" data-id="element-289">
                  Valor
                </span>
                <span className="font-bold text-brand-red" data-id="element-290">${item.value}</span>
              </div>
            </motion.div>)}

          <motion.div variants={itemVariants} className="mt-8 p-6 bg-brand-gray text-white rounded-2xl flex justify-between items-center shadow-xl" data-id="element-291">
            <span className="text-xl font-bold uppercase tracking-wider" data-id="element-292">
              Valor Total:
            </span>
            <span className="text-3xl font-bold line-through text-brand-red/80" data-id="element-293">
              $422
            </span>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}